<template>
  <div>
    <textarea
      name=""
      id="myArea"
      cols="30"
      rows="10"
      v-model="text"
      v-on:keyup="addLineBreak"
      @keypress.enter.prevent
    >
    </textarea>
    <div class="helper">
      <img
        class="icon-helper"
        src="@/assets/medias/images/title-html.png"
        alt=""
        @click="addHTML('title')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/paragraph-html.png"
        alt=""
        @click="addHTML('para')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/bold-html.png"
        alt=""
        @click="addHTML('strong')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/italic-html.png"
        alt=""
        @click="addHTML('italic')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/list-html.png"
        alt=""
        @click="addHTML('ol')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/ulist-html.png"
        alt=""
        @click="addHTML('ul')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/link-html.png"
        alt=""
        @click="addHTML('link')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/img-html.png"
        alt=""
        @click="addHTML('img')"
      />
      <img
        class="icon-helper"
        src="@/assets/medias/images/preview-html.png"
        alt=""
        @click="preview = true"
      />
    </div>
    <div v-if="userInput">
      <div>
        <input type="text" v-model="userLink" :placeholder="holder" />
        <button class="link-button" id="adding-link-button">Hop</button>
      </div>
    </div>
    <div v-if="preview" class="preview-bg">
      <div class="preview">
        <h2>Course content:</h2>
        <div class="X-close" @click="preview = false">X</div>
        <div v-html="text"></div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
export default {
  name: "HTMLHelper",
  data() {
    return {
      text: "",
      textarea: null,
      userInput: false,
      userLink: null,
      addingLink: false,
      addingImg: false,
      preview: false,
      holder: "paste your link here (no embedded stuff)",
    };
  },
  mounted() {
    this.textarea = document.getElementById("myArea");
  },
  methods: {
    async addHTML(param) {
      let toBeAdded, button;
      switch (param) {
        case "title":
          toBeAdded = "<h2></h2>";
          break;
        case "strong":
          toBeAdded = "<strong></strong>";
          break;
        case "italic":
          toBeAdded = "<i></i>";
          break;
        case "ol":
          toBeAdded = "<ol>\n<li>\n\n</li>\n</ol>";
          break;
        case "ul":
          toBeAdded = "<ul>\n<li>\n\n</li>\n</ul>";
          break;
        case "para":
          toBeAdded = "<p></p>";
          break;
        case "link":
          this.userInput = !this.userInput;
          this.addingUserInput(param);
          break;
        case "img":
          this.userInput = !this.userInput;
          this.addingUserInput(param);
          break;
      }
      if (param !== "link" && param !== "img") this.add(toBeAdded);
    },
    async addingUserInput(param) {
      while (document.getElementById("adding-link-button") == null) {
        await new Promise((r) => setTimeout(r, 500));
      }
      let button = document.getElementById("adding-link-button");
      button.onclick = () => {
        if (param == "link") this.addingUserLink();
        else this.addingUserImg();
      };
    },
    addingUserLink() {
      if (this.userLink !== null) {
        let toBeAdded =
          "<a href='" + this.userLink + "'>" + this.userLink + "</a>\n";
        this.add(toBeAdded);
        this.userInput = !this.userInput;
        this.userLink = null;
      } else {
        this.holder = "Nope, something's missing";
      }
    },
    addingUserImg() {
      if (this.userLink !== null) {
        let toBeAdded = "<img src='" + this.userLink + "'/>\n";
        this.add(toBeAdded);
        this.userInput = !this.userInput;
        this.userLink = null;
      } else {
        this.holder = "Nope, something's missing";
      }
    },
    add(toBeAdded) {
      this.text =
        this.text.substring(0, this.textarea.selectionStart) +
        toBeAdded +
        this.text.substring(this.textarea.selectionEnd, this.text.length);
    },
    addLineBreak(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        this.text =
          this.text.substring(0, this.textarea.selectionStart) +
          "<br/>" +
          "\n" +
          this.text.substring(this.textarea.selectionEnd, this.text.length);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  margin-top: 5px;
  margin-bottom: 50px;
}

.X-close {
  position: absolute;
  top: 3vh;
  right: 3vw;
  font-size: 3rem;
  color: red;
}

.preview-bg {
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
}

.preview {
  width: 66vw;
  height: 66vh;
  margin: auto;
  margin-top: 15vh;
}

input,
textarea {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  color: $light-grey;
  font-family: $font-stack;
  font-size: 1.5rem;
}

.link-button {
  margin: auto;
}

input {
  height: 2rem;
}

.helper {
  background-color: rgba(250, 250, 250, 0.5);
  width: 100%;
  height: 5vh;
  margin: auto;
  border-radius: 4px;
  width: max-content;
}

.icon-helper {
  height: 3vh;
  width: 1.5vw;
  margin: auto;
  padding: 1vh;
}
</style>
